import { defineMessages } from 'react-intl';

export const documentsTitle = defineMessages({
    link_open_banking: {
        id: 'document_title_link_open_banking',
        defaultMessage: 'Link your trading bank account'
    },
    via_open_banking: {
        id: 'document_title_via_open_banking',
        defaultMessage: 'Link your business bank account'
    },
    business_accounts: {
        id: 'document_title_business_accounts',
        defaultMessage: 'Most recent filed company accounts'
    },
    personal_bank_statement: {
        id: 'document_title_personal_bank_statement',
        defaultMessage: 'Last 3 months personal bank statements'
    },
    management_accounts: {
        id: 'document_title_management_accounts',
        defaultMessage: 'Current management accounts'
    },
    business_plan: {
        id: 'document_title_business_plan',
        defaultMessage: 'Business plan'
    },
    aged_debtor_report: {
        id: 'document_title_aged_debtor_report',
        defaultMessage: 'Aged debtor report'
    },
    bank_statement_with_quantifier: {
        id: 'document_title_bank_statement_with_quantifier',
        defaultMessage:
            'Last {quantifier} months of bank statements as PDF files'
    },
    bank_statement: {
        id: 'document_title_bank_statement',
        defaultMessage: 'Last bank statements as PDF files'
    },
    vat_return_with_quantifier: {
        id: 'document_title_vat_return_with_quantifier',
        defaultMessage: 'Last {quantifier} quarterly VAT returns'
    },
    vat_return: {
        id: 'document_title_vat_return',
        defaultMessage: "Last quarter's VAT return"
    },
    //  DE documents
    kontoauszuege_hochladen: {
        id: 'document_title_kontoauszuege_hochladen',
        defaultMessage: ' '
    },
    bwa_hochladen: {
        id: 'document_title_bwa_hochladen',
        defaultMessage: ' '
    },
    bwa_susa_hochladen: {
        id: 'document_title_bwa_susa_hochladen',
        defaultMessage: ' '
    },
    jaehrliche_bwa_susa_hochladen: {
        id: 'document_title_jaehrliche_bwa_susa_hochladen',
        defaultMessage: ' '
    },
    gesellschaftsvertrag_hochladen: {
        id: 'document_title_gesellschaftsvertrag_hochladen',
        defaultMessage: ' '
    },
    gewerbeschein_hochladen: {
        id: 'document_title_gewerbeschein_hochladen',
        defaultMessage: ' '
    },
    aktienregisterauszug_hochladen: {
        id: 'document_title_aktienregisterauszug_hochladen',
        defaultMessage: ' '
    }
});

export const documentSubTitles = defineMessages({
    management_accounts: {
        id: 'document_sub_title_management_accounts',
        defaultMessage:
            'These should include balance sheets and profit and loss'
    },
    aged_debtor_report: {
        id: 'document_sub_title_aged_debtor_report',
        defaultMessage:
            'This should include lists of all unpaid sales invoices, and show how much money you’re owed overall at a given date.'
    },
    bank_statement_with_quantifier: {
        id: 'document_sub_title_bank_statement_with_quantifier',
        defaultMessage: 'You can download these from your online banking'
    },
    bank_statement: {
        id: 'document_sub_title_bank_statement',
        defaultMessage: 'You can download this from your online banking'
    },
    vat_return_with_quantifier: {
        id: 'document_sub_title_vat_return_with_quantifier',
        defaultMessage: 'You can download these from HMRC'
    },
    vat_return: {
        id: 'document_sub_title_vat_return',
        defaultMessage: 'You can download this from HMRC'
    },

    //  DE documents
    kontoauszuege_hochladen: {
        id: 'document_sub_title_kontoauszuege_hochladen',
        defaultMessage: ' '
    },
    jaehrliche_bwa_susa_hochladen: {
        id: 'document_sub_title_jaehrliche_bwa_susa_hochladen',
        defaultMessage: ' '
    }
});
